import { Model } from "vue-mc";

export class Provincia extends Model {
  defaults() {
    return {
      clave: null
      , codigo: ""
      , nombre: ""
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , codigo: (codigo) => codigo
      , nombre: (nombre) => nombre
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/geograficos/provincia.js